// extracted by mini-css-extract-plugin
module.exports = {"_newSelectOption":"KfzKennzeichenAuswahl__newSelectOption__2VRS1"};